<main>
    <!-- HEADER -->
    <mat-card class="m-auto padding12 home-card boxshadowgrey">

        <div>
            <button mat-icon-button color="primary" class="back-button" routerLink="/machineState">
                <mat-icon>arrow_back</mat-icon>
            </button>
        </div>
        <div class="content">
        <mat-card-title-group class="home-card" id="title">
            <div class="header">
                <mat-card-title>{{"MASCHINESTATE.TIMES.HEADER" | translate}} </mat-card-title>

                
            </div>
        </mat-card-title-group>
        <!-- CONTENT -->
        <mat-card-content>
            <div class="home-card" id="content">
                <ng-container *ngIf="this.gatewayConnectionService.gatewayConnected == false"
                    >{{"MESSAGES.CONN_WAITING" | translate}}</ng-container
                >

                <ng-container *ngIf="this.gatewayConnectionService.gatewayConnected == true">
                    <div class="stack-wrapper">
                        <div class="background stack" id="wrapper">
                            <img
                                class="cabine-background"
                                id="image"
                                src="../../../../../../assets/images/machine/MachineSchematicCentered.svg"
                                alt=""
                                (load)="this.imgLoaded = true"
                            />
                        </div>

                        <ng-container *ngIf="this.imgLoaded == true">
                            <div class="value hour stack" id="machine">
                                <div class="value-block-title">{{"MASCHINESTATE.TIMES.MACHINE" | translate}}</div>
                                <div class="scrollable">
                                    <ng-container *ngFor="let datapoint of this.operationTimeDataset.dataPoints">
                                        <ng-container *ngIf="datapoint.position == this.positionEnum.Engine_Uppercarriage">
                                            <div class="datapoint borderred" id="wrapper">
                                                <div class="datapoint bordergreen" id="name">{{ datapoint.generalName | translate }}:</div>
                                                <div class="datapoint borderblue" id="value">{{ datapoint.value != 100794368 ? datapoint.value : '-' }} {{ datapoint.unit }}</div>
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                </div>
                                <!--<div class="datapoint borderred" id="wrapper">
                                    <div class="datapoint bordergreen" id="name">
                                        {{ this.operationTimeDataset.dataPoints[0].generalName | translate }}:
                                    </div>
                                    <div class="datapoint borderblue" id="value">{{ this.operationTimeDataset.dataPoints[0].value != 100794368 ? this.operationTimeDataset.dataPoints[0].value : '-' }} h</div>
                                </div>

                                <div class="datapoint borderred" id="wrapper">
                                    <div class="datapoint bordergreen" id="name">
                                        {{ this.operationTimeDataset.dataPoints[1].generalName | translate }}:
                                    </div>
                                    <div class="datapoint borderblue" id="value">{{ this.operationTimeDataset.dataPoints[1].value != 100794368 ? this.operationTimeDataset.dataPoints[1].value : '-' }} h</div>
                                </div>

                                <div class="datapoint borderred" id="wrapper">
                                    <div class="datapoint bordergreen" id="name">
                                        {{ this.operationTimeDataset.dataPoints[2].generalName | translate }}:
                                    </div>
                                    <div class="datapoint borderblue" id="value">{{ this.operationTimeDataset.dataPoints[2].value != 100794368 ? this.operationTimeDataset.dataPoints[2].value : '-' }} h</div>
                                </div>-->
                            </div>

                            <div class="value hour stack" id="boom-stick">
                                <div class="value-block-title">{{"MASCHINESTATE.TIMES.EQUIPMENT" | translate}}</div>
                                <div class="scrollable">
                                    <ng-container *ngFor="let datapoint of this.operationTimeDataset.dataPoints">
                                        <ng-container *ngIf="datapoint.position == this.positionEnum.Boom_Stick_Cylinder">
                                            <div class="datapoint borderred" id="wrapper">
                                                <div class="datapoint bordergreen" id="name">{{ datapoint.generalName | translate }}:</div>
                                                <div class="datapoint borderblue" id="value">{{ datapoint.value != 100794368 ? datapoint.value : '-' }} {{ datapoint.unit }}</div>
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                </div>
                                <!--<div class="datapoint borderred" id="wrapper">
                                    <div class="datapoint bordergreen" id="name">
                                        {{ this.operationTimeDataset.dataPoints[3].generalName | translate}}:
                                    </div>
                                    <div class="datapoint borderblue" id="value">{{ this.operationTimeDataset.dataPoints[3].value != 100794368 ? this.operationTimeDataset.dataPoints[3].value : '-' }} h</div>
                                </div>
                                <div class="datapoint borderred" id="wrapper">
                                    <div class="datapoint bordergreen" id="name">
                                        {{ this.operationTimeDataset.dataPoints[4].generalName | translate }}:
                                    </div>
                                    <div class="datapoint borderblue" id="value">{{ this.operationTimeDataset.dataPoints[4].value != 100794368 ? this.operationTimeDataset.dataPoints[4].value : '-' }} h</div>
                                </div>-->
                            </div>

                            <div class="value hour stack" id="tool">
                                <div class="value-block-title">{{"MASCHINESTATE.TIMES.TOOL" | translate}}</div>
                                <div class="scrollable">
                                    <ng-container *ngFor="let datapoint of this.operationTimeDataset.dataPoints">
                                        <ng-container *ngIf="datapoint.position == this.positionEnum.Tool">
                                            <div class="datapoint borderred" id="wrapper">
                                                <div class="datapoint bordergreen" id="name">{{ datapoint.generalName | translate }}:</div>
                                                <div class="datapoint borderblue" id="value">{{ datapoint.value != 100794368 ? datapoint.value : '-' }} {{ datapoint.unit }}</div>
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                </div>
                                <!--<div class="datapoint borderred" id="wrapper">
                                    <div class="datapoint bordergreen" id="name">
                                        {{ this.operationTimeDataset.dataPoints[5].generalName | translate}}:
                                    </div>
                                    <div class="datapoint borderblue" id="value">{{ this.operationTimeDataset.dataPoints[5].value != 100794368 ? this.operationTimeDataset.dataPoints[5].value : '-' }} h</div>
                                </div>
                                <div class="datapoint borderred" id="wrapper">
                                    <div class="datapoint bordergreen" id="name">
                                        {{ this.operationTimeDataset.dataPoints[6].generalName | translate}}:
                                    </div>
                                    <div class="datapoint borderblue" id="value">{{ this.operationTimeDataset.dataPoints[6].value != 100794368 ? this.operationTimeDataset.dataPoints[6].value : '-' }} h</div>
                                </div>-->
                            </div>

                            <div class="value hour stack" id="drive-slew">
                                <div class="value-block-title">{{"MASCHINESTATE.TIMES.DRIVE" | translate}}</div>
                                <div class="scrollable">
                                    <ng-container *ngFor="let datapoint of this.operationTimeDataset.dataPoints">
                                        <ng-container *ngIf="datapoint.position == this.positionEnum.Connection_Upper_Undercarriage">
                                            <div class="datapoint borderred" id="wrapper">
                                                <div class="datapoint bordergreen" id="name">{{ datapoint.generalName | translate }}:</div>
                                                <div class="datapoint borderblue" id="value">{{ datapoint.value != 100794368 ? datapoint.value : '-' }} {{ datapoint.unit }}</div>
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                </div>
                                <!--<div class="datapoint borderred" id="wrapper">
                                    <div class="datapoint bordergreen" id="name">
                                        {{ this.operationTimeDataset.dataPoints[7].generalName | translate}}:
                                    </div>
                                    <div class="datapoint borderblue" id="value">{{ this.operationTimeDataset.dataPoints[7].value != 100794368 ? this.operationTimeDataset.dataPoints[7].value : '-' }} h</div>
                                </div>
                                <div class="datapoint borderred" id="wrapper">
                                    <div class="datapoint bordergreen" id="name">
                                        {{ this.operationTimeDataset.dataPoints[8].generalName | translate}}:
                                    </div>
                                    <div class="datapoint borderblue" id="value">{{ this.operationTimeDataset.dataPoints[8].value != 100794368 ? this.operationTimeDataset.dataPoints[8].value : '-' }} h</div>
                                </div>
                                <div class="datapoint borderred" id="wrapper">
                                    <div class="datapoint bordergreen" id="name">
                                        {{ this.operationTimeDataset.dataPoints[9].generalName | translate}}:
                                    </div>
                                    <div class="datapoint borderblue" id="value">{{ this.operationTimeDataset.dataPoints[9].value != 100794368 ? this.operationTimeDataset.dataPoints[9].value : '-' }} h</div>
                                </div>-->
                            </div>
                        </ng-container>
                    </div>
                </ng-container>
            </div>
        </mat-card-content>
    </div>
    </mat-card>
</main>
